<template>
    <div :class="{
        'col-lg-25': !externalRegion || externalRegion === '' && screenWidth < 922,
        '': !externalRegion || externalRegion === '' && screenWidth >= 922,
        'd-none': externalRegion
    }">
        <div class="productsfilter productsfilter__searchwrapper">
            <div class="productsfilter__area">
                <!-- <h4>Suche</h4> -->
                <SearchBar></SearchBar>
            </div>
            <div class="productsfilter__area productsfilter__searchtoggle">
                <button
                    title="Hier durchsuchen Sie unsere Veranstaltungen!"
                    class="btn btn-outline" 
                    :class="{'productsfilter__searchtoggle--active' : eventStore.activeComponent === List}" 
                    :aria-label="`Suchoption 1 von 2 (${eventStore.activeComponent === List ? 'aktiv' : 'inaktiv'}): Suche in Veranstaltungen`"
                    @click="eventStore.toggleComponent(List)">Veranstaltungen
                </button>
                <button
                    title="Hier durchsuchen Sie die Website nach Inhalten!"
                    class="btn btn-outline" 
                    :class="{'productsfilter__searchtoggle--active' : eventStore.activeComponent === ContentSearchList}" 
                    :aria-label="`Suchoption 2 von 2 (${eventStore.activeComponent === ContentSearchList ? 'aktiv' : 'inaktiv'}): Suche global auf Website`"
                    @click="eventStore.toggleComponent(ContentSearchList)">Inhaltssuche
                </button>
            </div>
        </div>
        <div class="productsfilter__accordion" :class="{'productsfilter__accordion--open' : eventStore.eventSearchMode},{'open' : eventStore.openFilter}">
            <div class="productsfilter">
                <button @click="eventStore.openFilter=false" class="productsfilter__close">Schließen</button>
                <button @click="resetFilter" class="productsfilter__remove">Filter entfernen</button>
                <div class="productsfilter__area">
                    <h4>Themenwelt</h4>
                    <button @click="categoryAccordionOpen=!categoryAccordionOpen" type="button" :class="{'open' : categoryAccordionOpen}" class="productsfilter__accordionbutton" :aria-label="categoryAccordionOpen ? 'Filter für Themenbereiche zuklappen' : 'Filter für Themenbereiche aufklappen'" label="Themebereich">Themenbereich</button>
                    <template v-if="!eventStore.loading">
                        <div class="productsfilter__topics productsfilter__accordion">
                            <div class="productsfilter__accordionwrapper">
                                <CategoryButton
                                v-for="topic of eventStore.topics"
                                :id="topic.id"
                                :label="topic.label"
                                :count="eventStore.categoryEvents.filter(event => Object.values(event.categories).includes(topic.label)).length"
                                :key="topic.id"
                                @click="handleCategoriesToFilter(topic.id)"
                                />
                                <hr>
                                <CategoryButton
                                v-for="format of eventStore.formats"
                                :id="format.id"
                                :label="format.label"
                                :count="eventStore.categoryEvents.filter(event => Object.values(event.categories).includes(format.label)).length"
                                :key="format.id"
                                @click="handleCategoriesToFilter(format.id)"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- LOADING STATE -->
                        <div class="loading">
                            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                        </div>
                    </template>
                </div>
                <div class="productsfilter__area">
                    <h4>Veranstaltungsort</h4>
                    <button @click="placeAccordionOpen=!placeAccordionOpen" type="button" :class="{'open' : placeAccordionOpen}" class="productsfilter__accordionbutton" :aria-label="placeAccordionOpen ? 'Filter für Veranstaltungsort zuklappen' : 'Filter für Veranstaltungsort aufklappen'" label="Veranstaltungsort">Veranstaltungsort</button>
                    <div class="productsfilter__topics productsfilter__accordion">
                        <div class="productsfilter__accordionwrapper">
                            <Multiselect v-model="eventStore.placeToFilter" 
                            aria-label="Veranstaltungsort auswählen" 
                            :options="dropdownPlaces" 
                            :selectLabel="''" 
                            :selectedLabel="'entfernen'"
                            :deselectLabel="'entfernen'"
                            :placeholder="'Veranstaltungsort auswählen'"
                            :aria-expanded="placeIsOpen"
                            @open="placeIsOpen = true"
                            @close="placeIsOpen = false"
                            >
                                <template #noResult>Keine Ergebnisse...</template>
                                <template #noOptions>Keine Optionen verfügbar...</template>
                            </Multiselect>
                            <div class="grid-2">
                                <input v-model="tempPostcode" aria-label="PLZ" placeholder="PLZ-Suche" type="text" @input="eventStore.loadDistanceFilter(tempPostcode, tempDistance)">
                                <Multiselect v-model="tempDistance" 
                                aria-label="Umkreis in km auswählen" 
                                :options="dropdownDistance" 
                                @update:modelValue="eventStore.loadDistanceFilter(tempPostcode, tempDistance)" 
                                :selectLabel="''" 
                                :selectedLabel="'entfernen'" 
                                :deselectLabel="'entfernen'" 
                                :placeholder="'Umkreis'" 
                                :searchable="false"
                                :aria-expanded="distanceIsOpen"
                                @open="distanceIsOpen = true"
                                @close="distanceIsOpen=false"
                                >
                                    <template #noResult>Keine Ergebnisse...</template>
                                    <template #noOptions>Keine Optionen verfügbar...</template>
                                </Multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="productsfilter__area">
                    <h4>Regionalstelle</h4>
                    <Multiselect v-model="eventStore.regionIdToFilter"
                    id="regions"
                    aria-label="Regionalstelle auswählen" 
                    :options="formattedRegions" 
                    track-by="id" 
                    :label="'label'" 
                    :selectLabel="''" 
                    :selectedLabel="'entfernen'" 
                    :deselectLabel="'entfernen'" 
                    :placeholder="'Regionalstelle auswählen'"
                    :aria-expanded="regionIsOpen"
                    @open="regionIsOpen = true"
                    @close="regionIsOpen=false"
                    >
                        <template v-slot:option="{ option }">
                            <span>{{ option.name }}</span>
                        </template>
                        <template #noResult>Keine Ergebnisse...</template>
                        <template #noOptions>Keine Optionen verfügbar...</template>
                    </Multiselect>
                </div>
                <div class="productsfilter__area">
                    <h4>Preis</h4>
                    <div class="productsfilter__price">
                        <div class="productsfilter__priceinput">
                            <input v-model="tempLowerPrice" aria-label="Untere Preisgrenze" type="text" placeholder="0" autocomplete="off" @input="setPriceFilter">
                            <span>€</span>
                        </div>
                        <span>-</span>
                        <div class="productsfilter__priceinput">
                            <input v-model="tempUpperPrice" aria-label="Obere Preisgrenze" type="text" :placeholder="maxPrice" autocomplete="off" @input="setPriceFilter">
                            <span>€</span>
                        </div>
                    </div>
                </div>
                <div class="productsfilter__area productsfilter__calendar">
                    <h4>Zeitraum</h4>
                    <!-- <div>                    
                        <button class="btn btn-outline" aria-label="Nächste Woche" @click="setDateNextWeek">Nächste Woche</button>
                        <button class="btn btn-outline" aria-label="Nächsten Monat" @click="setDateNextMonth">Nächsten Monat</button>
                    </div> -->
                    <VueDatePicker
                    style="z-index: 0;"
                    :key="isInline"
                    range
                    :inline="isInline"
                    :clearable="true"
                    :enable-time-picker="false"
                    v-model="eventStore.dateToFilter"
                    ref="datepicker"
                    locale="de"
                    @range-end="lockDate"
                    :action-row="{ showSelect: false, showCancel: false, showNow: false, showPreview: false }"
                    :auto-position="true"     
                    :teleport="true"        
                    :position="isInline ? 'inline' : 'auto'"  
                    />
                    <div>
                        <button class="btn btn-outline-light" aria-label="Zeitraum entfernen" @click="resetDatePicker">Zeitraum entfernen</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="programteaser programteaser--filter">
            <p class="programteaser__title">
                <strong>Wir beraten Sie gerne in allen Fragen!</strong><br>
                Lesen Sie hier unsere <a href="https://ev-bildung.de/hilfe" class="underline">Tipps</a> oder nehmen Sie <a href="https://ev-bildung.de/kontakt-anfahrt" class="underline">Kontakt</a> mit uns auf!
            </p>            
            <a href="https://ev-bildung.de/jahresprogramme" class="programteaser__image" title="Aktuelles Jahresprogramm herunterladen">
                <span></span>
            </a>  
            <a href="https://ev-bildung.de/jahresprogramme" class="programteaser__download">
                <strong>Aktuelles Jahresprogramm</strong><br>
                herunterladen
            </a>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUnmounted, shallowRef, onBeforeMount } from "vue";
import { defineStore } from "pinia";

import VueDatePicker from '/node_modules/@vuepic/vue-datepicker'
import Multiselect from '/node_modules/vue-multiselect';

import CategoryButton from '../../components/Inputs/CategoryButton.vue';
import SearchBar from './SearchBar.vue';
import List from "./List.vue";
import ContentSearchList from "./ContentSearchList.vue";

const props = defineProps({
    externalRegion: String
})

const useEventStore = defineStore('event');

const eventStore = useEventStore();

const placeAccordionOpen = ref(false);
const categoryAccordionOpen = ref(false)

const datepicker = ref(null);
const isInline = computed(() => screenWidth.value < 992 || screenWidth.value >= 1399);

const dropdownPlaces = computed(() => eventStore.getPlaces);
const dropdownDistance = [
    '5km',
    '10km',
    '15km',
    '20km',
    '30km',
    '40km',
    '50km'
]
const tempPostcode = ref("");
const tempDistance = ref("");

const maxPrice = computed(() => eventStore.getMaxPrice);
const tempLowerPrice = ref();
const tempUpperPrice = ref();

const todayStart = new Date();
const todayEnd = new Date();
todayStart.setHours(0,0,0,0);
todayEnd.setHours(23,59,59,999);

const placeIsOpen = ref(false);
const distanceIsOpen = ref(false);
const regionIsOpen = ref(false);

const formattedRegions = computed(() => {
    return eventStore.regions.map(region => ({
        ...region,
        label: region.nameShort || region.name
    }))
})

function resetFilter() {
    tempLowerPrice.value = undefined;
    tempUpperPrice.value = undefined;
    tempDistance.value = undefined;
    tempPostcode.value = undefined;
    eventStore.resetFilter();
}

/*
*   Datum verarbeiten
*/

function lockDate() {
    setTimeout(() => {
        datepicker.value.selectDate();
    }, 0)
}

// function setDateToday() {
//     eventStore.dateToFilter = [todayStart, todayEnd];
// }

// function setDateNextWeek() {
//     const dayOfWeek = todayStart.getDay();
//     const daysUntilMonday = (8 - dayOfWeek) % 7;

//     const nextMonday = new Date(todayStart);
//     nextMonday.setDate(todayStart.getDate() + daysUntilMonday);

//     const followingSunday = new Date(nextMonday);
//     followingSunday.setDate(nextMonday.getDate() + 6);
//     followingSunday.setHours(23,59,59,999);

//     eventStore.dateToFilter = [nextMonday, followingSunday];
// }

// function setDateNextMonth() {
//   const currentMonth = todayStart.getMonth();
//   const currentYear = todayStart.getFullYear();

//   const nextMonthFirstDay = new Date(currentYear, currentMonth + 1, 1);
//   nextMonthFirstDay.setHours(0, 0, 0, 0);

//   const nextMonthLastDay = new Date(currentYear, currentMonth + 2, 0);
//   nextMonthLastDay.setHours(23, 59, 59, 999);

//   eventStore.dateToFilter = [nextMonthFirstDay, nextMonthLastDay];
// }

function resetDatePicker() {
    eventStore.dateToFilter = []
}

function handleCategoriesToFilter(categoryId) {    
    if(eventStore.categoryIdsToFilter.includes(categoryId)){
        const index = eventStore.categoryIdsToFilter.indexOf(categoryId);
        eventStore.categoryIdsToFilter.splice(index, 1);
    } else {
        eventStore.categoryIdsToFilter.push(categoryId);
    }
}

/*
*   Preis verarbeiten
*/

function setPriceFilter() {
    validatePriceInput(0);
    validatePriceInput(1);
    if(!tempLowerPrice.value) eventStore.pricesToFilter[0] = 0;
    else eventStore.pricesToFilter[0] = tempLowerPrice.value;

    if(!tempUpperPrice.value) eventStore.pricesToFilter[1] = maxPrice.value;
    else eventStore.pricesToFilter[1] = tempUpperPrice.value;
}

function validatePriceInput(index){
    let temp = "";

    if (index === 0) {
        if(tempLowerPrice.value){
            temp = tempLowerPrice.value.toString();
        }
    } else {
        if(tempUpperPrice.value) {
            temp = tempUpperPrice.value.toString();
        }
    }

    temp = temp.replace(/\D/g, '');

    if (temp.length > 4) {
        temp = temp.slice(0, 4);
    }

    if (index === 0) {
        tempLowerPrice.value = temp;
    } else {
        tempUpperPrice.value = temp;
    }
}

const oneTimeLoading = ref(true);

// URL Parameter extrahieren
const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);

const urlCategory = params.get("category");
const urlPlace = params.get("place");
const urlPostcode = params.get("postcode");
const urlDistance = params.get("distance");
const urlRegion = params.get("region");
const urlPrice = params.get("price");
const urlDate = params.get("date");
eventStore.eventSearchMode = !(params.get("searchMode") === "false");

if(eventStore.eventSearchMode == false) {
    eventStore.activeComponent = ContentSearchList;
} else {
    eventStore.activeComponent = List;
}

// Region updaten, wenn regions geladen wurden
watch(() => eventStore.regions, newRegions => {
    if(newRegions.length > 0 && oneTimeLoading.value){
        for(const reg of newRegions){
            if(reg.id == urlRegion) eventStore.regionIdToFilter = reg;
        }
        oneTimeLoading.value = false;
    }
})


onBeforeMount(async () => {
    await eventStore.loadRegions();
})

onMounted(() => {
    // URL Parameter anwenden
    if(urlCategory) {
        const categories = [...urlCategory.split(',')];
        
        for(const cat of categories) {
            handleCategoriesToFilter(cat);
        }
    }
    if(urlPlace) {
        eventStore.placeToFilter = urlPlace;
    }
    if(urlPostcode && urlDistance) {
        tempPostcode.value = urlPostcode;
        tempDistance.value = urlDistance + "km";
        eventStore.loadDistanceFilter(urlPostcode, urlDistance)
    }
    if(urlPrice) {
        const [lower, upper] = urlPrice.split(',');
        tempLowerPrice.value = lower;
        tempUpperPrice.value = upper;
        setPriceFilter();
    }
    if(urlDate){
        const splitDate = [...urlDate.split(",")];
        const start = new Date(splitDate[0]);
        const end = new Date(splitDate[1]);
        eventStore.dateToFilter = [start, end];
    }   


    window.addEventListener('resize', updateScreenWidth);
})

onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth);
})

const screenWidth = ref(window.innerWidth);

const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
}

/**
 * add titles to vue-multiselect
 */
// onMounted(() => {
//     setTimeout(() => {
//         const ulRegions = document.getElementById('listbox-regions');
//         console.log('List:', ulRegions);
        
//         if (ulRegions) {
//             const liElements = ulRegions.querySelectorAll('.multiselect__element');
//             console.log('Listelements:', liElements);
            
//             liElements.forEach(li => {
//                 const titleSpan = li.querySelector('span.multiselect__option');
//                 console.log('Title:', titleSpan);
                
//                 const contentSpan = titleSpan.querySelector('span');
//                 console.log('Content:', contentSpan);
                
//                 if (contentSpan) {
//                     li.setAttribute('title', contentSpan.innerHTML);
//                 }
//             });
//         }
//     }, 500)
// })

watch(() => eventStore.loading, newVal => {
    if(!newVal) {
        const ulRegions = document.getElementById('listbox-regions');
        if (ulRegions) {
            const liElements = ulRegions.querySelectorAll('.multiselect__element');
            liElements.forEach(li => {
                const titleSpan = li.querySelector('span.multiselect__option');
                const contentSpan = titleSpan.querySelector('span');
                if (contentSpan) {
                    li.setAttribute('title', contentSpan.innerHTML);
                }
            });
        }
    }
})


// VueDatepicker Accessibility Aria anpassungen
function updateAriaAttributes(element) {
  if (element.hasAttribute('aria-pressed')) {
    const isPressed = element.getAttribute('aria-pressed') === 'true';
    element.setAttribute('aria-selected', isPressed.toString());
    element.removeAttribute('aria-pressed');
  }
}

// Funktion zur Verarbeitung aller relevanten Elemente
function processElements() {
  const elements = document.querySelectorAll('[aria-pressed]');
  elements.forEach(updateAriaAttributes);
}

// Konfiguration des MutationObserver
const config = { attributes: true, childList: true, subtree: true };

// Callback-Funktion für den MutationObserver
const callback = function(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' || 
        (mutation.type === 'attributes' && mutation.attributeName === 'aria-pressed')) {
      processElements();
    }
  }
};

// Erstellen und Starten des MutationObserver
const observer = new MutationObserver(callback);
observer.observe(document.body, config);
</script>
